{
  "version": 1,
  "asset_id": "cd7b9681-7a80-45fb-b45f-a2144173e62a",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/cd7b9681-7a80-45fb-b45f-a2144173e62a/hernando-galvalume-metal-roof-destination-roofing-1200w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/cd7b9681-7a80-45fb-b45f-a2144173e62a/hernando-galvalume-metal-roof-destination-roofing-1200w.webp",
  "original_filename": "hernando-galvalume-metal-roof-destination-roofing-1200w.webp",
  "size": 194012,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:52Z"
}
